var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPostMealDrink = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#AA4DBF",
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.1 17c-.916 0-1.816.13-2.7.387a8.49 8.49 0 0 0-2.45 1.163L15 28h10l1.1-10h-.7a9.912 9.912 0 0 1-1.725-.137c-.516-.092-1.225-.271-2.125-.538a6.958 6.958 0 0 0-1.2-.25c-.416-.05-.833-.075-1.25-.075Zm-5.4-.625c.85-.45 1.73-.792 2.638-1.025a11.16 11.16 0 0 1 5.737.05c.834.233 1.471.392 1.913.475.442.083.912.125 1.412.125h.925l.425-4h-13.5l.45 4.375ZM14.975 30c-.516 0-.962-.167-1.337-.5A1.887 1.887 0 0 1 13 28.225l-1.725-15.75c-.083-.667.1-1.246.55-1.737A2.179 2.179 0 0 1 13.5 10h13c.667 0 1.225.246 1.675.738.45.491.634 1.07.55 1.737L27 28.225c-.05.517-.262.942-.637 1.275-.375.333-.82.5-1.338.5h-10.05Z"
})));
SvgPostMealDrink.viewBox = '0 0 40 40';
const ForwardRef = /*#__PURE__*/forwardRef(SvgPostMealDrink);
export default ForwardRef;